import { LabelHTMLAttributes, forwardRef } from 'react';
import './Form.css';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** Mark the field as required */
  required?: boolean;
}

/**
 * Label component for form fields.
 *
 * @example
 * ```tsx
 * <Label htmlFor="email" required>
 *   Email Address
 * </Label>
 * ```
 */
export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ required = false, className = '', children, ...props }, ref) => {
    const classNames = ['ui-label', className].filter(Boolean).join(' ');

    return (
      <label ref={ref} className={classNames} {...props}>
        {children}
        {required && <span className="ui-label__required">*</span>}
      </label>
    );
  }
);

Label.displayName = 'Label';
